import Types from "./Types";

export const getAllSuperadminSectionsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_SECTIONS_REQUEST,
  payload: body,
});

export const getAllSuperadminSectionsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_SECTIONS_SUCCESS,
  payload: data,
});

export const getAllSuperadminSectionsFail = () => ({
  type: Types.GET_SUPERADMIN_SECTIONS_FAIL,
});

export const editSuperadminSectionRequest = (formData, action) => ({
  type: Types.EDIT_SUPERADMIN_SECTION_REQUEST,
  payload: formData,
  action: action,
});

export const editSuperadminSectionSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_SECTION_SUCCESS,
  payload: data,
});

export const editSuperadminSectionFail = () => ({
  type: Types.EDIT_SUPERADMIN_SECTION_FAIL,
});

//LOADING
export const addSuperadminSectionLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_SECTIONS_LOADING,
  payload: isLoading,
});

// Create SuperadminSection
export const createSuperadminSectionRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_SECTION_REQUEST,
  payload: formData,
  action: action,
});

export const createSuperadminSectionSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_SECTION_SUCCESS,
  payload: {
    data,
  },
});

export const createSuperadminSectionFail = () => ({
  type: Types.CREATE_SUPERADMIN_SECTION_FAIL,
});

export const deleteSuperadminSectionRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_SECTION_REQUEST,
  payload: id,
});

export const deleteSuperadminSectionSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_SECTION_SUCCESS,
  payload: id,
});

export const deleteSuperadminSectionFail = () => ({
  type: Types.DELETE_SUPERADMIN_SECTION_FAIL,
});

export const getCourseSectionRequest = (id) => ({
  type: Types.SUPERADMIN_GET_COURSE_SECTION_REQUEST,
  payload: id,
});

export const getCourseSectionSuccess = (id) => ({
  type: Types.SUPERADMIN_GET_COURSE_SECTION_SUCCESS,
  payload: id,
});

export const getCourseSectionFail = () => ({
  type: Types.SUPERADMIN_GET_COURSE_SECTION_FAIL,
});
